
require('./angular-mailcheck');

var MODULE_NAME = 'mailcheck';

angular.module(MODULE_NAME, ['tf.mailcheck']);

module.exports = MODULE_NAME;



// WEBPACK FOOTER //
// ./src/app/common/core/vendor/angular-mailcheck/index.js